export default ({ request }) => ({
  sampleStockReturnListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/list',
      method: 'post',
      data
    })
  },
  sampleStockReturnDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/detail',
      method: 'post',
      data
    })
  },
  sampleStockReturnSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/save',
      method: 'post',
      data
    })
  },
  sampleStockReturnDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/del',
      method: 'post',
      data
    })
  },
  sampleStockReturnAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billStockReturnMain/audit',
      method: 'post',
      data
    })
  }
})
